import { render, staticRenderFns } from "./ProfileDetailsBaseComponent.vue?vue&type=template&id=60e80476&"
import script from "./ProfileDetailsBaseComponent.vue?vue&type=script&lang=ts&"
export * from "./ProfileDetailsBaseComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e80476')) {
      api.createRecord('60e80476', component.options)
    } else {
      api.reload('60e80476', component.options)
    }
    module.hot.accept("./ProfileDetailsBaseComponent.vue?vue&type=template&id=60e80476&", function () {
      api.rerender('60e80476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/ProfileDetailsBaseComponent.vue"
export default component.exports